module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    staticClass: "center",
    attrs: {
      "wide": true,
      "fullwide": true,
      "show-close": true,
      "click-outside": false
    },
    on: {
      "close": _vm.localClose
    }
  }, [_c('Slideshow', {
    staticStyle: {
      "width": "100vw",
      "max-width": "100%"
    },
    attrs: {
      "images": _vm.params.images,
      "fullsize": true,
      "image": _vm.params.image
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53217d59"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/SlideshowModal.vue
// module id = 956
// module chunks = 0